export default __webpack_public_path__ + "static/media/cse-top-pick-circle-2019.7e1e4149.png";